/*
 * @Descripttion: 短信模板
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useEffect} from 'react';
import { Tab } from "@alifd/next";
import CustomDefinition from './components/CustomDefinition';
import SystemTemplate from './components/SystemTemplate';
import utils from '@/common/utils';

const SMSTemplate = ():JSX.Element => {

  useEffect(() => {

    utils.setBreadcrumb({
      name: '短信模板', // 一级页面名称
      url: '/web/smstemplate', // 一级页面url
    });
  }, []);

  return (
    <>
      <div>
        <Tab navStyle={{ background: "#ffffff" }}>
          <Tab.Item title="自定义模板" key="1">
            <CustomDefinition/>
          </Tab.Item>
          <Tab.Item title="系统模板" key="2">
            <SystemTemplate/>
          </Tab.Item>
        </Tab>
      </div>

    </>
  )
}

export default SMSTemplate;
